export default __webpack_public_path__ + "static/media/brokenImageUpload.15e63250.png";